import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import Skeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    progress: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 3,
        zIndex: theme.zIndex.modal + 1,
        pointerEvents: 'none',
    },
    row: {
        display: 'grid',
        gap: theme.spacing(2),
        padding: theme.spacing(1.5, 2),
        borderBottom: '1px solid var(--dm-border, #e7ebf0)',
    },
}));

export function LoadingProgress({ label = 'Loading results' }) {
    const classes = useStyles();
    return <LinearProgress className={classes.progress} aria-label={label} />;
}

export default function ContentLoading({ columns = 3, rows = 4, minHeight = 160 }) {
    const classes = useStyles();
    return (
        <div role="status" aria-label="Loading results" aria-busy="true" style={{ minHeight, width: '100%' }}>
            <LoadingProgress />
            {Array.from({ length: rows }, (_, row) => (
                <div key={row} className={classes.row} style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }} aria-hidden="true">
                    {Array.from({ length: columns }, (_, column) => (
                        <Skeleton key={column} variant="text" width="85%" height={24} />
                    ))}
                </div>
            ))}
        </div>
    );
}
